<template>
    <div id="home">
        <div
            class="list"
            v-for="(v,i) in data"
            :key="i"
            :style="{paddingBottom:v.appName=='墨迹天气IPC'?'0':'.2rem'}"
        >
            <!-- 标题 所有版本-->
            <div class="title">
                <!-- 标题 -->
                <p v-html="v.appName"></p>
                <!-- 所有版本 -->
                <div @click="all(v.appName,v.appType,v.id,v.appIdentifier)">
                    <span>{{v.appType==2?"Android":"IPhone"}}全部版本</span>
                    <img src="../assets/img/返回1@2x.png" />
                </div>
            </div>
            <!-- 下载 -->
            <Download
                :v="v"
                :i="i"
                type="home"
            ></Download>
        </div>

        <!-- 请求loading -->
        <Loading :showloading="showloading"></Loading>
    </div>
</template>

<script>
export default {
    name: "home",
    data() {
        return {
            data: [],
            showflag: null,
            showloading: true
        };
    },
    methods: {
        //跳转详情页
        all(name, type, id, appIdentifier) {
            // 保存历史
            var arr = [];
            if (localStorage.getItem("clickItem")) {
                arr = localStorage.getItem("clickItem").split(",");
            }
            if (arr.indexOf(id) === -1) {
                arr.push(id);
            }
            localStorage.setItem("clickItem", arr.join(","));
            //跳转,判断是否是在本地运行
            if (location.hash) {
                this.$router.push({
                    path: "/detail",
                    query: { appIdentifier }
                });
            } else {
                var url =
                    location.href.split("home.html")[0] +
                    `detail.html?appIdentifier=${appIdentifier}`;
                location.href = url;
            }
        },
        //检查历史
        checkHistory(id) {
            var arr;
            if (localStorage.getItem("clickItem") == undefined) {
                return true;
            } else {
                arr = localStorage.getItem("clickItem").split(",");
                return arr.indexOf(id) == -1 ? true : false;
            }
        }
    },
    mounted() {
        if (navigator.onLine) {
            this.showloading = true;
            var url = "https://co.moji.com/api/pgerself/infoNew";
            this.$jsonp(url).then(data => {
                if (data.code == 0) {
                    var data = data.data;
                    data.forEach((v, i) => {
                        if (v.appName == "墨迹天气") {
                            //给每一个app加是否为新版
                            v.isnew = this.checkHistory(v.id);
                        }
                    });
                    var data1 = data.sort((a, b) => {
                        return a.appType - b.appType;
                    });
                    this.data = data1;
                }
                this.showloading = false;
            });
        } else {
            this.showloading = false;
        }
    }
};
</script>

<style lang="scss" scoped>
#home {
    -webkit-overflow-scrolling: touch;
    max-width: 750px;
    margin: 0 auto;
    .list {
        background: #fff;
        padding-top: 0.2rem;
        padding-bottom: 0.2rem;
        border-radius: 0.05rem;
        box-shadow: 0 0.07rem 0.1rem 0.07rem #e7e9f7;
        margin: 0.22rem 0.16rem;
        > div {
            padding: 0 0.14rem;
        }
        .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
                font-size: 0.22rem;
                font-weight: 500;
                color: #323232;
            }
            div {
                display: flex;
                justify-content: center;
                align-items: center;
                span {
                    font-size: 0.14rem;
                    color: #999999;
                }
                img {
                    height: 0.14rem;
                    margin-left: 0.11rem;
                }
            }
        }
    }
}
</style>

